import { css } from 'styled-components';
import reset from 'styled-reset';

const CommonResetStyle = css`
  ${reset};
`;

export { CommonResetStyle };
